import React, { FC } from 'react'

const CurvyLine2: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1252"
    height="832"
    viewBox="0 0 1252 832"
    fill="none"
  >
    <path
      stroke="#71757D"
      strokeDasharray="14 14"
      strokeLinecap="round"
      strokeOpacity=".5"
      strokeWidth="2"
      d="M830 1c-51 141 421 79.499 421 306.999 0 227.5-225 195.999-451 195.999H215.114c-48.5 0-204.877-6.496-212.995 143.003C-6 796.5 81.999 831 81.999 831"
    />
  </svg>
)

export default CurvyLine2
